module.exports = __webpack_public_path__ + "static/media/joelsequeira.7a139803.jpeg";